import React, { useState, useEffect } from 'react';
import { Carousel } from 'react-responsive-carousel';
import 'react-responsive-carousel/lib/styles/carousel.min.css';
import { Link } from 'react-router-dom';
import DomoticNavbar from '../Components/Navbar';
import "../Components/navbar.css";
import "./security-cctv.css";
import cctv1 from "./img-domotic/electrosec_cctv1.png"
import cctv2 from "./img-domotic/electrosec_cctv1.png"
import cctv3 from "./img-domotic/electrosec_cctv1.png"

import hikvision from "./img-domotic/electrosec_cctv1.png"
import dahua from "./img-domotic/electrosec_cctv1.png"
import axis from "./img-domotic/electrosec_cctv1.png"
import bosch from "./img-domotic/electrosec_cctv1.png"

const SecurityCCTV = () => {
  const [showMenu, setShowMenu] = useState(false);

  // Datos específicos para Electro Seguridad
  const imagenesGaleria = [
    { src: cctv1, alt: "Sistema de CCTV completo", caption: "Soluciones integradas de videovigilancia" },
  ];

  const servicios = [
    {
      icon: "👁️",
      titulo: "Videovigilancia",
      descripcion: "Sistemas CCTV analógicos e IP con las últimas tecnologías.",
      features: ["Cámaras 4K/8K", "Visión nocturna", "Analítica de video"]
    },
    {
      icon: "🚨",
      titulo: "Alarmas Inteligentes",
      descripcion: "Sistemas de detección de intrusiones con verificación visual.",
      features: ["Sensores inalámbricos", "Notificaciones en tiempo real", "Integración con CCTV"]
    },
    {
      icon: "🔐",
      titulo: "Control de Acceso",
      descripcion: "Sistemas electrónicos para gestión de ingresos seguros.",
      features: ["Reconocimiento facial", "Tarjetas RFID", "Biometría"]
    },
    {
      icon: "🖥️",
      titulo: "Monitoreo Remoto",
      descripcion: "Plataformas para supervisión desde cualquier dispositivo.",
      features: ["App móvil", "Almacenamiento en la nube", "Multiplataforma"]
    }
  ];

  const tiposSoluciones = [
    {
      categoria: "Residencial",
      items: [
        "Sistemas para hogares",
        "Videoporteros inteligentes",
        "Alarmas verificadas",
        "Domótica integrada"
      ]
    },
    {
      categoria: "Comercial",
      items: [
        "Retail security",
        "Bancos y financieras",
        "Centros comerciales",
        "Oficinas corporativas"
      ]
    },
    {
      categoria: "Industrial",
      items: [
        "Plantas manufactureras",
        "Puertos y logística",
        "Infraestructura crítica",
        "Almacenes"
      ]
    }
  ];

  const marcas = [
    { nombre: "Hikvision", logo: hikvision },
    { nombre: "Dahua", logo: dahua },
    { nombre: "Axis", logo: axis },
    { nombre: "Bosch Security", logo: bosch },
    { nombre: "Hanwha Techwin", logo: "/marcas/hanwha.png" },
    { nombre: "Avigilon", logo: "/marcas/avigilon.png" }
  ];

  // Efecto de scroll reveal
  useEffect(() => {
    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('visible');
        }
      });
    }, { threshold: 0.1 });

    document.querySelectorAll('.security-scroll-reveal').forEach(el => {
      observer.observe(el);
    });

    return () => observer.disconnect();
  }, []);

  return (
    <div className="security-container">
      <DomoticNavbar/>
      
      {/* Hero Section */}
      <section className="security-hero">
        <div className="security-hero-content">
          <h1 className="security-hero-title">Electro Seguridad y CCTV</h1>
          <p className="security-hero-subtitle">
            Soluciones tecnológicas para protección integral
          </p>
        </div>
      </section>

      {/* Galería de Imágenes */}
      <section className="security-gallery security-scroll-reveal">
        {imagenesGaleria.map((img, index) => (
          <div key={index} className="security-gallery-item">
            <img 
              src={img.src} 
              alt={img.alt}
              className="security-gallery-img"
            />
            <div className="security-gallery-caption">
              <p>{img.caption}</p>
            </div>
          </div>
        ))}
      </section>

        {/* Sección de Características con Imágenes de Fondo */}
<section className="ryn-features-section">
  <div className="ryn-features-container">
    <h2 className="ryn-features-title">Nuestras Soluciones de CCTV</h2>
    <p className="ryn-features-subtitle">Tecnología avanzada para seguridad empresarial</p>
    
    <div className="ryn-features-grid">
   
      
      {/* Característica 3 */}
      <div className="ryn-feature-card">
        <div className="ryn-feature-content">
          <h3 className="ryn-feature-title">SEGURIDAD ELECTRÓNICA</h3>
          <p className="ryn-feature-desc">Video Vigilancia, Accesos, Alarmas y soluciones especializadas</p>
          <ul className="ryn-feature-list">
            <li>Sistemas de video vigilancia:  con inteligencia artificial y con reconocimiento facial, con   reconocimiento de placas, cámaras personales (body cams), cámaras móviles para vehículos con GPS, cámaras robóticas, térmicas y de control perimetral.</li>
            <li>Sistemas de Alarmas y sistemas control de accesos y asistencia de personal</li>
            <li>Software especializado para gestión de monitore o y  analítica con IA</li>
            <li>Smart lockers con reconocimiento facial</li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</section>  





    </div>
  );
};

export default SecurityCCTV;